import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const socials = [{
  platform: "YouTube",
  handle: "@MacaroniCapital",
  initial: "Y",
  desc: "Watch our latest educational series and market breakdowns."
}, {
  platform: "X",
  handle: "@MacaroniCapital",
  initial: "X",
  desc: "Real-time updates, quick tips, and community discussions."
}, {
  platform: "Facebook",
  handle: "@MacaroniCapital",
  initial: "F",
  desc: "Join our community group for shared learning and support."
}, {
  platform: "TikTok",
  handle: "@MacaroniCapital",
  initial: "T",
  desc: "Bite-sized trading concepts and platform highlights."
}, {
  platform: "Instagram",
  handle: "@MacaroniCapital",
  initial: "I",
  desc: "Visual guides, infographics, and behind-the-scenes."
}, {
  platform: "Substack",
  handle: "macaronicapital.substack.com",
  initial: "S",
  desc: "In-depth articles, weekly planners, and detailed analysis."
}];
const quickLinks = [{
  title: "Home",
  url: "/HomePage"
}, {
  title: "How It Works",
  url: "/HowItWorksPage"
}, {
  title: "The Planner",
  url: "/ThePlannerPage"
}, {
  title: "Caddie",
  url: "/CaddiePage"
}, {
  title: "Connect",
  url: "/ConnectPage"
}];
export default function TheNetwork() {
  return <section id="the-network" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {socials.map((social, i) => <Card key={social.platform} data-index={i} className="rounded-none border-border bg-card hover:border-primary/50 transition-colors">
              <CardContent className="p-8 flex flex-col gap-6">
                <div className="size-[44px] border border-primary flex items-center justify-center text-primary font-sans text-xl font-semibold shrink-0">
                  {social.initial}
                </div>
                <div>
                  <h3 className="font-sans text-xl text-foreground mb-2">
                    {social.handle}
                  </h3>
                  <p className="font-serif text-muted-foreground text-lg leading-relaxed">
                    {social.desc}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="flex flex-col gap-4 max-w-3xl mx-auto">
          {quickLinks.map((link, i) => <Button key={link.title} data-index={i} asChild variant="outline" className="w-full justify-between rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground font-sans h-16 px-6 text-lg transition-colors">
              <Link to={link.url}>
                {link.title}
                <ArrowRight className="size-5" />
              </Link>
            </Button>)}
        </div>
      </div>
    </section>;
}